import { HttpParams, httpResource } from '@angular/common/http';
import { computed, runInInjectionContext } from '@angular/core';
import { noCategoryId, widgetHttpHeader } from 'scw-digital-boards-widgets';
import { actionTrackerContext } from '../../../../core/interceptors/api-interceptor.interceptor';
import { ActionTrackerService } from '../../../../core/services/action-tracker.service';
import { IItemCategory } from '../../../../pages/dashboard-content/widget-add-edit-dialog/widget-add-edit-dialog.interface';
import { IBaseResponse } from '../../../../utilities/http-utilities.service';
import { AdvancedFilterApiMatcher } from './advanced-filter-api-matcher';

export class ItemCategoryAdvancedFilterApiMatcher extends AdvancedFilterApiMatcher {
  private readonly isIdValidationSkipped = this.id === noCategoryId;
  public override idValidationResource = runInInjectionContext(this.injector, () =>
    httpResource<IBaseResponse<IItemCategory>>(() =>
      this.isIdValidationSkipped
        ? undefined
        : {
            context: actionTrackerContext,
            headers: widgetHttpHeader,
            method: 'GET',
            params: new HttpParams().set('fields', 'id,name'),
            reportProgress: true,
            url: `item-categories/${this.id}`,
          },
    ),
  );

  public override label = computed(() => {
    if (this.isIdValidationSkipped) {
      return this.translate.instant('widget.sqcdpMonthly.sqcdpType.noCategory');
    }

    const itemCategory = this.idValidationResource.value()?.data;

    return this.idValidationResource.status() === 'resolved'
      ? !itemCategory?.isDefault
        ? (itemCategory?.name ?? '...')
        : (ActionTrackerService.getitemCategoryTypeOptions(this.translate).find(
            (option) => option.id === itemCategory?.name,
          )?.name ?? '...')
      : '...';
  });

  public override isInvalid(): boolean | null {
    return !this.isIdValidationSkipped && super.isInvalid();
  }
}
